export class ArmadoresModel {
  id: number;
  nome: string;
}



// WEBPACK FOOTER //
// ./src/app/armadores/armadores.model.ts